import { FormControl } from '@angular/forms';
import {
  BaseNewRequestControlName,
  InvestorDetailsNewRequestFormGroup,
} from '../../../../../shared/base-new-request-form/base-new-request-form.model';

export enum SFMPNewRequestAdditionalControlName {
  Purpose = 'purpose',
}

export const SFMPNewRequestControlName = {
  ...BaseNewRequestControlName,
  ...SFMPNewRequestAdditionalControlName,
};

export interface SFMPNewRequestFormGroup
  extends InvestorDetailsNewRequestFormGroup {
  [SFMPNewRequestControlName.Purpose]: FormControl<string>;
}
